import { render, staticRenderFns } from "./approvel-record.vue?vue&type=template&id=0e0eae1c"
import script from "./approvel-record.vue?vue&type=script&lang=js"
export * from "./approvel-record.vue?vue&type=script&lang=js"
import style0 from "./approvel-record.vue?vue&type=style&index=0&id=0e0eae1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports